var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[(_vm.showCompany)?_c('e2-svg',{staticClass:"company-logo",attrs:{"name":"company"}}):_vm._e(),(_vm.showCompany)?_c('a-divider',{attrs:{"type":"vertical"}}):_vm._e(),_c('span',[_vm._v("ACS")]),(_vm.showTitle)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }